import loadBposNavBarData from './orchestrators/loadBposNavBarData';
import { runAfterSessionData } from 'owa-delayed-initialization';

runAfterSessionData(() => {
    loadBposNavBarData();
});

export { default as getBposNavBarData } from './utils/getBposNavBarData';
